import React, { useState } from 'react';
import Row from 'olive-react-myoneui/lib/Row';
import Col from 'olive-react-myoneui/lib/Col';
import { CircleImage } from 'olive-react-myoneui';
import NoItems from './NoItems';
import { noAnnouncementBadge } from '../../../constants/icons';

const CourseAnnouncements = ({
  className,
  announcements
}) => {
  const [expandedId, setExpandedId] = useState(null);

  const toggleDescription = (id) => {
    setExpandedId(prevId => prevId === id ? null : id);
  };

  return (
    <div className={`${className || ''} myk__stu-courses-announce-wrapper w-100`}>
      <Row>
        <Col lg={12}>
          <h2>Announcements <span>({announcements.length})</span></h2>
        </Col>
        <Col lg={12}>

        {announcements.length > 0 ? (
          <div className="myk__stu-announcement-items">
            {announcements.map((announcement) => (
            <div className="myk__stu-announcement mb-4" key={announcement.id}>
              <div className="information-holder align-items-start mb-2">
                <CircleImage className="circle-wrap circle-wrap-md border-0">
                  {announcement.imageSrc !== '' ? (
                    <img src={announcement.imageSrc} className="img-fluid" alt="announcement" />
                  ) : (
                    <div className="circle-wrap circle-wrap-md bg-circle-twilight text-white">
                      {announcement.posterName[0]}
                    </div>
                  )}
                </CircleImage>
                <div className="information-detail">
                  <div className="myk__stu-announce_header">
                    <h3>{announcement.title}</h3>
                    <ul className="m-0 p-0 d-flex align-items-center gap-2 list-style-none myk__stu-annonce-metadata">
                      <li>{announcement.posterName}</li>
                      <li>{announcement.date}</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="myk__stu-announce-desc">
                <div
                  dangerouslySetInnerHTML={{
                    __html: expandedId === announcement.id
                      ? announcement.description
                      : announcement.descriptionLength > 500 ? `${announcement.description.substring(0, 500)}...` : announcement.description
                  }}
                />
                {announcement.descriptionLength > 500 &&
                <span
                  className="btn btn-transparent mt-2 p-0"
                  onClick={() => toggleDescription(announcement.id)}
                >
                  {expandedId === announcement.id ? "Show Less" : "Read More"}
                </span>
                }
              </div>
            </div>
            ))}
            </div>
            ):(
              <NoItems
                icon={noAnnouncementBadge}
                title="No Announcements to show!"
                description="There are no announcements posted for this course!"
              />
            )}
          </Col>
      </Row>
    </div>
  );
};

export default CourseAnnouncements;
